import styles from './CtaSidebar.module.css';

function CtaSidebar({ ctas }) {
  if (!ctas || ctas.length === 0) {
    return null;
  }

  return (
    <aside className={styles.ctaSidebar}>
      <h4>Actions</h4>
      <div className={styles.buttonGroup}>
        {ctas.map((cta, index) => (
          <a
            key={index}
            href={cta.url}
            target="_blank"
            rel="noopener noreferrer"
            className="action-button secondary"
          >
            {cta.icon && <i className={`${cta.icon} ${styles.icon}`}></i>}
            <span>{cta.label}</span>
          </a>
        ))}
      </div>
    </aside>
  );
}

export default CtaSidebar;
